export enum SymmioAccessType {
    WebAccess = "Web Assessment Only",
    AppLicense = "MySymmio Access",
}